var pug = require("!../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Ciframe src=\"https:\u002F\u002F32001nc.ambifox.net\u002Findex.php\u002Fs\u002FdiiCwZjmuvBFTdo\" style=\"width: 100%; height: 500px\"\u003E\u003C\u002Fiframe\u003E";;return pug_html;};
module.exports = template;